/**
 * اصلاح در ماهِ حضورِ نهایی‌شده (v2.124.0).
 *
 * کاربر (۱۴۰۵/۰۷/۰۵): «اصلاحِ ورود/خروج نیاز به تأییدِ مدیریت دارد ولی نه جایی کد می‌پرسد و نه برای مدیرِ اصلی پیامی
 * برای تأیید می‌رود». سرور کدِ مدیریتی را قبول می‌کرد ولی صفحه‌ها هرگز نمی‌پرسیدند. حالا:
 *   ۱) پنجرهٔ «کدِ مدیریتی» ⇒ همان درخواست با کد دوباره فرستاده می‌شود؛
 *   ۲) یا «ارسالِ درخواست به مدیر» ⇒ اعلان برای مدیرِ اصلی با دکمهٔ «تأیید و اعمال» (صفحهٔ یادداشت‌ها).
 */
import React from "react";
import { Button, Input, Modal, Space, Typography, message } from "antd";
import { createAttendanceChangeRequest } from "../api/client";

const { Text } = Typography;

export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : (d?.message || fallback);
};

export const isMonthLocked = (e) => e?.response?.status === 403
  && (e?.response?.data?.detail?.code === "month_locked" || /نهایی شده.*کد مدیریتی/.test(errText(e, "")));

/**
 * `call(pin)` را اجرا می‌کند؛ اگر ماه قفل بود کد می‌پرسد یا درخواست به مدیر می‌فرستد.
 * `request`: بدنهٔ درخواستِ مدیر (employee_id, work_date, check_in, check_out) — اگر نباشد فقط کد پرسیده می‌شود.
 * خروجی: نتیجهٔ `call`، یا `{requested: true}`، یا null (انصراف).
 */
export async function runWithAdminPin(call, { request } = {}) {
  try {
    return await call(undefined);
  } catch (e) {
    if (!isMonthLocked(e)) throw e;
  }
  return new Promise((resolve) => {
    let pin = "";
    const inst = Modal.confirm({
      title: "حضورِ این ماه نهایی شده",
      width: 460,
      content: (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Text>برای ثبتِ این اصلاح، کدِ مدیریتی را وارد کنید:</Text>
          <Input.Password autoFocus placeholder="کد مدیریتی" onChange={(ev) => { pin = ev.target.value; }}
            onPressEnter={() => document.querySelector(".gx-pin-ok")?.click()} />
          {request && (
            <>
              <Text type="secondary" style={{ fontSize: 12 }}>کد را ندارید؟ درخواست برای مدیرِ اصلی فرستاده شود تا تأیید کند:</Text>
              <Button block onClick={async () => {
                try {
                  const r = await createAttendanceChangeRequest(request);
                  message.success(r.data?.message || "درخواست برای مدیر فرستاده شد");
                  inst.destroy(); resolve({ requested: true });
                } catch (err) { message.error(errText(err, "ارسالِ درخواست ناموفق بود")); }
              }}>ارسالِ درخواست به مدیر</Button>
            </>
          )}
        </Space>
      ),
      okText: "ثبت با کد", cancelText: "انصراف",
      okButtonProps: { className: "gx-pin-ok" },
      onOk: async () => {
        if (!pin) { message.warning("کد مدیریتی را وارد کنید"); throw new Error("no pin"); }
        try {
          const out = await call(pin);
          resolve(out);
        } catch (err) {
          message.error(errText(err, "کد مدیریتی نادرست است"));
          throw err;          // پنجره باز بماند
        }
      },
      onCancel: () => resolve(null),
    });
  });
}
